import { Popover } from '@mui/material';
import { withStyles } from '@mui/styles';

export const AntPopover = withStyles(theme => ({
    root: {},
    paper: {
        borderRadius: 20,
    },
}))(Popover);
